import DefaultModal from './DefaultModal'

export default DefaultModal
